import React, { useState } from 'react';
import Login from './components/Login';
import VeegbewijsForm from './components/VeegbewijsForm';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleBack = () => {
    setIsAuthenticated(false);
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <VeegbewijsForm onBack={handleBack} />
      )}
    </div>
  );
}

export default App;